import PropTypes from 'prop-types';
import React from 'react';
import { inputStyle, labelStyle } from './styles';

const Select = ({
  label,
  name,
  value,
  children,
  disabled,
  onChangeSelect,
}) => (
  <>
    <label htmlFor={label} style={labelStyle}>
      <div style={{ paddingBottom: '4px' }}>{label}</div>
      <select
        id={label}
        defaultValue={value}
        aria-label={label}
        name={name}
        disabled={disabled}
        onChange={onChangeSelect}
        style={inputStyle}
      >
        {children}
      </select>
    </label>
  </>
);

Select.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  onChangeSelect: PropTypes.func,
};

Select.defaultProps = {
  disabled: false,
  onChangeSelect: () => {},
  label: '',
  value: '',
};

export default Select;
